// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

//scroll anchor links under the header (ei tuotesivulla: estää scrollaus lisätietoihin sivulle tultaessa)
/* $(document).ready( function() {
    if ($('body').hasClass('single-product') && window.location.hash) {
        // Tuotesivulla: estetään scrollaus lisätietoihin – pysytään ylhäällä, hash pois URL:sta
        function scrollProductToTop() {
            $('html, body').scrollTop(0);
        }
        scrollProductToTop();
        setTimeout(scrollProductToTop, 0);
        setTimeout(scrollProductToTop, 100);
        $(window).on('load', scrollProductToTop);
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
    } else if (window.location.hash) {
        var $target = $(window.location.hash)
        var headerHeight = $('header').height()
        if($target.length > 0) {
            $('html, body').animate({scrollTop: $target.offset().top - headerHeight } , 400);
        }
    }
    $(document).on('click', 'a[href*="#"]:not(.slicknav_btn)', function(e) {
        e.preventDefault();
        var href = $(this).attr("href");
        let current_url = window.location.href.split('#')[0];
        if( ( href.startsWith("#") || href.startsWith(current_url + "#") ) && href !== '#' ) {
            var target = href.split("#")[1]
            if( $('#' + target).length > 0 ) {
                var headerHeight = $('header').height()
                $('html, body').animate({scrollTop: $('#' + target).offset().top - headerHeight } , 400);
            }
        } else {
            window.location.href = href;
        }
    })
}) */